import React from 'react';
import { Dog, Cat, Bird, Rabbit, PawPrint, LucideIcon } from 'lucide-react';

interface PetAvatarProps {
  name: string;
  species?: string;
  size?: number;
  className?: string;
}

// Hayvana özgü ikon eşleştirme
const speciesIcon: Record<string, LucideIcon> = {
  dog: Dog,
  cat: Cat,
  bird: Bird,
  rabbit: Rabbit,
  other: PawPrint,
};

// Gradient renk paletleri — modern, profesyonel
const GRADIENTS: [string, string][] = [
  ['#fb923c', '#f97316'], // turuncu
  ['#a78bfa', '#7c3aed'], // mor
  ['#8FA862', '#557236'], // teal
  ['#60a5fa', '#2563eb'], // mavi
  ['#f472b6', '#db2777'], // pembe
  ['#34d399', '#059669'], // yeşil
  ['#fbbf24', '#d97706'], // amber
  ['#22d3ee', '#0891b2'], // cyan
  ['#f87171', '#dc2626'], // kırmızı
  ['#818cf8', '#4f46e5'], // indigo
];

// İsmin hash'inden tutarlı renk seç
const hashString = (str: string): number => {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = (h << 5) - h + str.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
};

const PetAvatar: React.FC<PetAvatarProps> = ({
  name,
  species = 'other',
  size = 48,
  className = '',
}) => {
  const Icon = speciesIcon[species] || PawPrint;
  const palette = GRADIENTS[hashString(name || 'pet') % GRADIENTS.length];
  const iconSize = size * 0.5;

  return (
    <div
      className={`relative flex items-center justify-center text-white shadow-md overflow-hidden ${className}`}
      style={{
        width: size,
        height: size,
        borderRadius: size * 0.28,
        background: `linear-gradient(135deg, ${palette[0]} 0%, ${palette[1]} 100%)`,
        boxShadow: `0 4px 12px ${palette[1]}40`,
      }}
    >
      {/* Hafif vurgu */}
      <div
        className="absolute top-0 left-0 right-0 h-1/2 opacity-20"
        style={{
          background: 'linear-gradient(180deg, rgba(255,255,255,0.4) 0%, transparent 100%)',
        }}
      />
      <Icon size={iconSize} strokeWidth={2.2} className="relative" />
    </div>
  );
};

export default PetAvatar;
